export default function HinesvilleAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Passport Acceptance Clerks
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Hinesville, GA
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-6">
            First-time applicants — and most applicants who are not eligible for a standard mail-in renewal or a second passport — must apply in person at a passport acceptance clerk, and all locations require an appointment. This is the self-service option, typically chosen by those on a tighter budget who have at least 1–2+ months before travel and don't mind the slower, standard processing times.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-amber-600 text-base"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                If you want to use a registered U.S. Department of State courier to receive your passport in as little as 3 days, you must sign up with{" "}
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors"
                >
                  Fast Passport Center
                </a>{" "}
                <strong>before</strong> going to the clerk. Once you apply at the clerk, your documents are sent through the standard route, and we cannot intervene or upgrade it to an expedited courier service afterward.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-mail-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Hinesville Main Post Office</h3>
                <span className="text-xs text-gray-400 font-medium">USPS Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>1802 W Oglethorpe Hwy, Hinesville, GA 31313</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:8002758777" className="hover:text-[#1A365D] transition-colors">800-275-8777</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 9am–5pm, Sat 9am–12pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Central Hinesville</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Schedule Appointment</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Central Hinesville location near Fort Stewart. Appointment required. Confirm photo services when booking.</p>
            </div>
          </article>

          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-mail-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Richmond Hill Post Office</h3>
                <span className="text-xs text-gray-400 font-medium">USPS Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>11980 Ford Ave, Richmond Hill, GA 31324</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:8002758777" className="hover:text-[#1A365D] transition-colors">800-275-8777</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 9am–5pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Richmond Hill (~15 mi east)</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Schedule Appointment</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Bryan County option east of Hinesville near I-95. Call to confirm passport acceptance hours.</p>
            </div>
          </article>

          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-mail-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Midway Post Office</h3>
                <span className="text-xs text-gray-400 font-medium">USPS Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>303 S Coastal Hwy, Midway, GA 31320</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:8002758777" className="hover:text-[#1A365D] transition-colors">800-275-8777</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 9am–5pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Midway (~12 mi east)</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Schedule Appointment</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Small-town post office east of Hinesville. Confirm passport services available before visiting.</p>
            </div>
          </article>

          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-mail-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Jesup Post Office</h3>
                <span className="text-xs text-gray-400 font-medium">USPS Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>145 S Palm St, Jesup, GA 31545</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:8002758777" className="hover:text-[#1A365D] transition-colors">800-275-8777</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 9am–5pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Jesup (~25 mi west)</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Schedule Appointment</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Wayne County option west of Hinesville. Call to confirm passport acceptance hours.</p>
            </div>
          </article>

          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-government-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Liberty County Clerk of Superior Court</h3>
                <span className="text-xs text-gray-400 font-medium">County Clerk Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>201 S Main St, Hinesville, GA 31313</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:9128763625" className="hover:text-[#1A365D] transition-colors">912-876-3625</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 8am–5pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Downtown Hinesville</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://www.libertycountyga.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Clerk Passport Info</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Liberty County option in downtown Hinesville. Confirm appointments and accepted payments before visiting.</p>
            </div>
          </article>

          <article className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className="ri-mail-line text-[#F6C344] text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">Savannah Main Post Office</h3>
                <span className="text-xs text-gray-400 font-medium">USPS Passport Acceptance</span>
              </div>
            </div>
            <div className="space-y-2 flex-1">
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>127 Fahm St, Savannah, GA 31401</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="tel:8002758777" className="hover:text-[#1A365D] transition-colors">800-275-8777</a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                <span>Mon–Fri 9am–5pm, Sat 9am–12pm</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <span>Savannah (~40 mi northeast)</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">Schedule Appointment</a>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-start gap-2 mb-3">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed italic">Chatham County option in downtown Savannah. Full passport services. Appointment required. Call to confirm.</p>
            </div>
          </article>
        </div>

        <div className="bg-[#1A365D] rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-xl"></i>
            </div>
            <div>
              <p className="font-bold text-white text-base mb-1">Last chance — sign up now, before your clerk visit</p>
              <p className="text-white/70 text-sm leading-relaxed max-w-xl">If you need your expedited passport fast, sign up with Fast Passport Center <strong className="text-white">before</strong> you walk into that clerk appointment. Once your documents go through the standard route, they're gone — there's no pulling them back, no upgrading, no saving you after the fact. Don't wait and hope it works out.</p>
            </div>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}